// extracted by mini-css-extract-plugin
export default {"button":"FirstButton_button__H375u"};